import React from 'react';
import './ShinyText.css';

interface ShinyTextProps {
  text: string;
  disabled?: boolean;
  speed?: number;
  className?: string;
  variant?: 'blue' | 'black-white' | 'yellow' | 'orange' | 'red';
}

const ShinyText: React.FC<ShinyTextProps> = ({ 
  text, 
  disabled = false, 
  speed = 2, 
  className = '',
  variant = 'blue'
}) => {
  const animationDuration = `${speed}s`;

  const getVariantClass = () => {
    switch (variant) {
      case 'black-white':
        return 'shiny-text-bw';
      case 'yellow':
        return 'shiny-text-yellow';
      case 'orange':
        return 'shiny-text-orange';
      case 'red':
        return 'shiny-text-red';
      default:
        return '';
    }
  };

  return (
    <div 
      className={`shiny-text ${getVariantClass()} ${disabled ? 'disabled' : ''} ${className}`} 
      style={{ animationDuration }}
    >
      {text}
    </div>
  );
};

export default ShinyText;
